var modules_16ab616e = {"wrapper":"_12siume"};
import "../../../assets/BH9-MdlA.css";

export { modules_16ab616e as default };
//# sourceMappingURL=ultimate-special-offers.module.scss.js.map
